import * as React from "react";
import { Link, styled } from "@mui/material";
import {
  ConfigMetaData,
  ConfigurationDottedKey,
} from "@kahunmedical/common-configuration/dist/lib/annotations";
import clsx from "clsx";

//region [[ Styles ]]

const KahnSettingsBreadcrumbsView = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
});

const LastKey = styled("div")({
  fontWeight: 700,
  color: "#5A52C3",
  fontSize: "14px",
  lineHeight: "21px",
  marginLeft: "5px",
  // In case it's the only child and there are no bread crumbs behind no need in margin
  "&:first-child": {
    marginLeft: 0,
  },
});

const BreadCrumbButton = styled(Link)({
  fontWeight: 200,
  color: "#5A52C3",
  fontSize: "14px",
  lineHeight: "21px",
  margin: "0 5px",
  cursor: "pointer",
  "&:first-child": {
    marginLeft: 0,
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface KahnSettingsBreadcrumbsProps {
  className?: string;
  root: ConfigurationDottedKey;
  onPathChanged: (newPath: ConfigurationDottedKey) => void;
  path?: ConfigMetaData[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const KahnSettingsBreadcrumbs = ({
  root,
  ...props
}: KahnSettingsBreadcrumbsProps) => {
  return (
    <KahnSettingsBreadcrumbsView
      className={clsx(props.className, "kahun-settings-bread-crumbs")}
    >
      {root?.split(".")?.map?.((key, index, array) => {
        const isLast = index === array.length - 1;

        if (isLast) return <LastKey key={key}>{key}</LastKey>;

        return (
          <React.Fragment key={key}>
            <BreadCrumbButton
              onClick={() =>
                props.onPathChanged(array.slice(0, index + 1).join("."))
              }
            >
              {key}
            </BreadCrumbButton>
            <span> / </span>
          </React.Fragment>
        );
      })}
    </KahnSettingsBreadcrumbsView>
  );
};
